import { render, staticRenderFns } from "./LoginByPwdOrCode.vue?vue&type=template&id=421d2d8a&scoped=true&"
import script from "./LoginByPwdOrCode.vue?vue&type=script&lang=js&"
export * from "./LoginByPwdOrCode.vue?vue&type=script&lang=js&"
import style0 from "./LoginByPwdOrCode.vue?vue&type=style&index=0&id=421d2d8a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421d2d8a",
  null
  
)

export default component.exports